import {REGIONS_STORE_NAME} from '../reducers/reducers'

export function getRegions(state) {
    const stored = state[REGIONS_STORE_NAME] || { }
    return stored.items
}
